//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions, mapState } from "vuex";
import orderItems from "./OrderItems";

export default {
  components: { orderItems: orderItems },

  data() {
    return {
      order: {},
      orderStatus: "",
      orderNumber: "",
      tab: "details",
      tabCustomer: "customerTab",
      id: 0,
      rowCount: 10,
      existingOrder: false,
      dense: true,
      orderDate: date.formatDate(Date.now(), "DD-MM-YYYY"),
      deliveryDate: date.formatDate(Date.now(), "DD-MM-YYYY"),
    };
  },

  computed: {
    ...mapState("main", ["warehouses", "locations"]),
  },

  methods: {
    async refresh() {
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.id = this.$route.params.id;
      if (this.id > 0) {
        await this.fetchOrder(this.id);
        this.existingOrder = true;
      }

      setTimeout(() => {
        notif();
      }, 500);
    },

    async itemsChanged(data) {
    
      this.order = data;
      this.setOrderStatus();
    },

    async fetchOrder(id) {
      const data = await this.getSalesOrder(id);
      this.order = data;
      this.orderNumber = this.order.orderNumber.toString();
      this.mapOrder(data);
      this.setOrderStatus();
    },

    mapOrder(data) {
      (this.orderDate = date.formatDate(data.orderDate, "DD-MM-YYYY")),
        (this.deliveryDate = date.formatDate(data.deliveryDate, "DD-MM-YYYY"));
    },

    setOrderStatus() {
      this.orderStatus = this.$t(
        "order.status-" + this.order.customerOrderStatusId
      );
    },

    ...mapActions("main", ["getSalesOrder", "getCustomer"]),
  },

  async created() {
    // GET request using fetch with error handling

    this.id = this.$route.params.id;
    if (this.id > 0) {
      await this.fetchOrder(this.id);
      this.existingOrder = true;
    }
  },
};
